import ForgetPWBackground from "../components/forgetPassword/ForgetPWBackground";

function ForgetPassword() {
    return (
        <ForgetPWBackground />
    );
}

export default ForgetPassword;